<div class="card container-fluid p-5">
  <div class="mb-4 flex items-center justify-between">
    <h1 class="text-3xl font-semibold">{{ 'invoices.title' | translate }}</h1>
  </div>
  <app-invoice-table
    (viewInvoiceDetails)="onViewInvoiceDetails($event)"
    (editInvoiceDetails)="onEditInvoiceDetails($event)"
    (downloadInvoicePdf)="onDownloadInvoicePdf($event)"
  ></app-invoice-table>
</div>
